class VersionChecker {
  constructor() {
    this.currentVersion = null;
    this.listeners = [];
    this.checksRemaining = 3; // ✅ Solo 3 verificaciones
    this.checkTimeouts = [];
  }

  async init() {
    try {
      const res = await fetch("/version.json?_=" + Date.now(), {
        method: "GET",
        cache: "no-store",
        headers: {
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
      });

      if (!res.ok) throw new Error("Error");

      const data = await res.json();
      this.currentVersion = data.version;
    } catch (e) {
      this.currentVersion = "1.0.0";
    }
  }

  async check() {
    if (this.checksRemaining <= 0) return null; // ✅ Detener si no quedan checks

    this.checksRemaining--;

    try {
      const res = await fetch("/version.json?_=" + Date.now(), {
        method: "GET",
        cache: "no-store",
        headers: {
          "Cache-Control": "no-cache, no-store, must-revalidate",
          Pragma: "no-cache",
          Expires: "0",
        },
      });

      if (!res.ok) return null;

      const data = await res.json();

      if (data.version !== this.currentVersion) {
        this.stop();
        this.listeners.forEach((cb) => cb(data.version));
        return data.version;
      }
    } catch (e) {
      // Silenciar
    }
    return null;
  }

  onUpdate(callback) {
    this.listeners.push(callback);
  }

  start() {
    // ✅ Solo 3 verificaciones programadas

    // Check #1: A los 10 segundos
    this.checkTimeouts.push(setTimeout(() => this.check(), 10000));

    // Check #2: A los 30 segundos
    this.checkTimeouts.push(setTimeout(() => this.check(), 30000));

    // Check #3: A los 60 segundos
    this.checkTimeouts.push(setTimeout(() => this.check(), 60000));
  }

  stop() {
    // Limpiar todos los timeouts
    this.checkTimeouts.forEach((timeout) => clearTimeout(timeout));
    this.checkTimeouts = [];
    this.checksRemaining = 0;
  }

  async reload() {
    this.stop();

    const token = localStorage.getItem("token");
    const sessionToken = localStorage.getItem("session_token");

    if (token && sessionToken) {
      try {
        const response = await fetch(process.env.VUE_APP_ROOT_API + "/user", {
          headers: {
            Authorization: "Bearer " + token,
            "X-Session-Token": sessionToken,
          },
        });

        if (!response.ok) {
          window.location.href = "/#/login?reason=session_expired";
          return;
        }
      } catch (e) {
        window.location.href = "/#/login?reason=session_expired";
        return;
      }
    }

    localStorage.removeItem("update_dismiss_count");
    localStorage.removeItem("update_postponed_until");
    localStorage.removeItem("last_update_version");

    if ("caches" in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }

    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then((regs) => {
        regs.forEach((reg) => reg.unregister());
      });
    }

    setTimeout(() => {
      window.location.reload();
    }, 100);
  }
}

const instance = new VersionChecker();
export default instance;
